import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import 'react-web-vector-icons/fonts';

ReactDOM.render(<App />, document.getElementById('root'));
